import * as t from "io-ts";
import nullable from "./nullable";
import { CargoExtraCo2BaseT } from "./cargo-extra-co2";
import { createCargoTypes } from "./cargo";
import { withFallback } from "io-ts-types";
export const createCargoTemplateTypes = ({ decimal, date, dateTime, }) => {
    const { baseCargoWithoutRefT, stopT, addStopUnitT, editStopUnitInputT, editStopUnitOutputT, createCargoInvoiceLineT, } = createCargoTypes({
        decimal,
        date,
        dateTime,
    });
    const postCargoTemplateT = t.intersection([
        baseCargoWithoutRefT,
        t.type({
            pickupList: t.array(stopT),
            dropoffList: t.array(stopT),
            stopUnits: withFallback(t.array(addStopUnitT), []),
            extraCo2Elements: t.array(CargoExtraCo2BaseT),
        }),
        t.partial({
            invoiceLines: t.array(createCargoInvoiceLineT),
        }),
    ]);
    const idT = t.strict({ id: t.string });
    const optionalIdT = t.partial({ id: t.string });
    const editStopOutputT = t.intersection([stopT, idT]);
    const editStopInputT = t.intersection([stopT, optionalIdT]);
    const editCargoTemplateOutputT = t.intersection([
        baseCargoWithoutRefT,
        idT,
        t.type({
            deliveryId: nullable(t.string),
            canBeDeleted: t.boolean,
            pickupList: t.array(editStopOutputT),
            dropoffList: t.array(editStopOutputT),
            stopUnits: t.array(editStopUnitOutputT),
            totalLm: decimal,
            totalWeight: nullable(decimal),
            revision: t.string,
            extraCo2Elements: t.array(CargoExtraCo2BaseT),
            hasBeenSplit: t.boolean,
            originalRouteIdBeforeSplit: nullable(t.string),
            splitFromCargoId: nullable(t.string),
        }),
    ]);
    const editCargoTemplateInputT = t.intersection([
        baseCargoWithoutRefT,
        t.type({
            pickupList: t.array(editStopInputT),
            dropoffList: t.array(editStopInputT),
            stopUnits: withFallback(t.array(editStopUnitInputT), []),
            extraCo2Elements: t.array(CargoExtraCo2BaseT),
        }),
    ]);
    return {
        editCargoTemplateInputT,
        editCargoTemplateOutputT,
        postCargoTemplateT,
        stopT,
        editStopInputT,
        editStopOutputT,
    };
};
//# sourceMappingURL=cargo-template.js.map